import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';
import {
  IDefaultDevicesSettingsDTO,
} from '@/../client-generator/generated-clients/device-settings';
import ShutterActuatorSettings from '@/views/components/DeviceSettings/ShutterActuatorSettings/ShutterActuatorSettings.vue';
import ShutterCommandSettings from '@/views/components/DeviceSettings/ShutterCommandSettings/ShutterCommandSettings.vue';
import LightsActuatorSettings from '@/views/components/DeviceSettings/LightsActuatorSettings/LightsActuatorSettings.vue';
import LightsCommandSettings from '@/views/components/DeviceSettings/LightsCommandSettings/LightsCommandSettings.vue';
import LocksCommandSettings from '@/views/components/DeviceSettings/LocksCommandSettings/LocksCommandSettings.vue';
import LocksActuatorSettings from '@/views/components/DeviceSettings/LocksActuatorSettings/LocksActuatorSettings.vue';

@Options({
  name: 'ObjectSettings',
  props: {
    defaultSettings: {
      type: Object as PropType<IDefaultDevicesSettingsDTO>,
      required: true,
    },
    deviceName: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:defaultSettings'],
  components: {
    ShutterActuatorSettings,
    ShutterCommandSettings,
    LocksCommandSettings,
    LocksActuatorSettings,
    LightsCommandSettings,
    LightsActuatorSettings,
  },
})
export default class ObjectSettings extends Vue {
  defaultSettings!: IDefaultDevicesSettingsDTO;
  deviceName!: string;
  readonly!: boolean;

  get activeSettingsComponent() {
    if (this.defaultSettings?.shuttersActuatorSettings != null) {
      return 'ShutterActuatorSettings';
    }
    if (this.defaultSettings?.shuttersCommandSettings != null) {
      return 'ShutterCommandSettings';
    }
    if (this.defaultSettings?.lightsActuatorSettings != null) {
      return 'LightsActuatorSettings';
    }
    if (this.defaultSettings?.lightsCommandSettings != null) {
      return 'LightsCommandSettings';
    }
    if (this.defaultSettings?.lockCommandSettings != null) {
      return 'LocksCommandSettings';
    }
    if (this.defaultSettings?.lockActuatorSettings != null) {
      return 'LocksActuatorSettings';
    }
    if (this.defaultSettings?.thermoProbeSettings != null) {
      return 'ThermoProbeSettings';
    }
    return '';
  }
}
